export default {
  'component.contentmanagement.title': 'Tawk.to widget-kode for DS',
  'component.contentmanagement.description':
    'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam.',
  'component.contentmanagement.towidgetcode': 'Tawk.to widget-kode',
  'component.contentmanagement.towidgetcode.placeholder': 'Skriv inn Tawk.to widget-kode',
};
